import React from 'react'
import { Title } from '@/modules/base/components/texts'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => {
  return {
    root: {
      position: 'relative',
      '&.disabled': {
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.9)',
        },
      },

    },
    title: {
      fontWeight: theme.fontWeights.medium,
      fontSize: theme.fontSizes.smedium,
      marginBottom: 30,
    },

  }
})

const SettingSection = (props) => {
  const { title, children, disabled = false } = props
  const classes = useStyles()
  return (
    <div className={clsx(classes.root, { disabled })}>
      <Title className={classes.title}>{title}</Title>
      {children}
    </div>
  )
}

SettingSection.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default SettingSection
